import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Award, Calendar, HeadphonesIcon, Briefcase, CheckCircle2 } from 'lucide-react';

const WhyUs = () => {
  const { t } = useLanguage();

  const icons = [Award, Calendar, HeadphonesIcon, Briefcase];
  const colors = [
    { bg: 'bg-sky-100', text: 'text-sky-500' },
    { bg: 'bg-cyan-100', text: 'text-cyan-500' },
    { bg: 'bg-blue-100', text: 'text-blue-500' },
    { bg: 'bg-indigo-100', text: 'text-indigo-500' }
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 bg-sky-100 text-sky-600 text-sm font-medium rounded-full mb-4">
            {t.why.title}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            {t.why.subtitle}
          </h2>
        </div>

        {/* Features */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.why.items.map((item, index) => {
            const Icon = icons[index];
            const color = colors[index];
            return (
              <div
                key={index}
                className="relative group"
              >
                <div className="bg-white rounded-2xl p-8 h-full shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                  {/* Icon */}
                  <div className={`w-14 h-14 ${color.bg} rounded-2xl flex items-center justify-center mb-6`}>
                    <Icon className={`w-7 h-7 ${color.text}`} />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold text-slate-800 mb-3">{item.title}</h3>
                  <p className="text-slate-500 leading-relaxed">{item.desc}</p>

                  {/* Check Mark */}
                  <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                    <CheckCircle2 className="w-5 h-5 text-green-400" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
